module.exports = __webpack_public_path__ + "img/driver.4d0ee934.png";